import React from "react";
import PropTypes from "prop-types";
import Datetime from "react-datetime";
import DateTimePicker from 'react-datetime-picker';
import moment from "moment"
import { db, firebase } from "firebase/fbConfig.js"
import axios from 'axios'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import Icon from "@material-ui/core/Icon";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomDropdown from 'components/CustomDropdown/CustomDropdown.jsx';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import styles from "assets/jss/material-dashboard-pro-react/components/profileFormStyle.jsx";

import { updateVendor } from "store/actions/profileActions.jsx"
import VendorPicUpload from "components/CustomUpload/vendorPicUpload.jsx";

// Assets
import precincts from "variables/precincts.jsx"

class Form extends React.Component {

  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      ...this.state,
      airCodes: (this.props.vendor.airCodes ? this.props.vendor.airCodes : []),
      marketAreas: (this.props.vendor.marketAreas ? this.props.vendor.marketAreas : []),
      relatedBranches: (this.props.vendor.relatedBranches ? this.props.vendor.relatedBranches : []),
      relatedAirports: (this.props.vendor.relatedAirports ? this.props.vendor.relatedAirports : []),
      mailingIsPhysical: (this.props.vendor.mailingIsPhysical ? this.props.vendor.mailingIsPhysical : ''),
      sta: (this.props.vendor.sta ? this.props.vendor.sta : ''),
      vendorType: this.props.vendor.vendorType ? this.props.vendor.vendorType : '',
      physicalAddress: this.props.vendor.physicalAddress ? this.props.vendor.physicalAddress : "",
      physicalCity: this.props.vendor.physicalCity ? this.props.vendor.physicalCity : "",
      physicalState: this.props.vendor.physicalState ? this.props.vendor.physicalState : "",
      physicalZip: this.props.vendor.physicalZip ? this.props.vendor.physicalZip : "",
      hours: this.props.vendor.hours ? this.props.vendor.hours : ""
    };

    this.allMAString = "All 48 States";
  }

  handleDOBChange = (dob) => {
    console.log(dob._d)
    if (dob) {
      this.setState(() => ({ dob: dob._d }))
    }
  }


  // componentDidMount = () => {
  //   var inputElement = document.getElementById('mainPhone');
  //   inputElement.removeEventListener('keydown', this.enforceFormat);
  //   inputElement.removeEventListener('keyup', this.formatToPhone);
  //   var inputElement2 = document.getElementById('mainPhone');
  //   inputElement2.removeEventListener('keydown', this.enforceFormat);
  //   inputElement2.removeEventListener('keyup', this.formatToPhone);

  // }

  // componentWillUnmount = () => {
  //   var inputElement = document.getElementById('mainPhone');
  //   inputElement.removeEventListener('keydown', this.enforceFormat);
  //   inputElement.removeEventListener('keyup', this.formatToPhone);
  //   var inputElement2 = document.getElementById('mainPhone');
  //   inputElement2.removeEventListener('keydown', this.enforceFormat);
  //   inputElement2.removeEventListener('keyup', this.formatToPhone);

  // }

  //Phone number code modified from
  // https://stackoverflow.com/questions/30058927/format-a-phone-number-as-a-user-types-using-pure-javascript 
  isNumericInput = (event) => {
    const key = event.keyCode;
    return ((key >= 48 && key <= 57) || // Allow number line
      (key >= 96 && key <= 105) // Allow number pad
    );
  };

  isModifierKey = (event) => {
    const key = event.keyCode;
    return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
      (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
      (key > 36 && key < 41) || // Allow left, up, right, down
      (
        // Allow Ctrl/Command + A,C,V,X,Z
        (event.ctrlKey === true || event.metaKey === true) &&
        (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
      )
  };

  enforceFormat = (event) => {
    // Input must be of a valid number format or a modifier key, and not longer than ten digits
    if (!this.isNumericInput(event) && !this.isModifierKey(event)) {
      event.preventDefault();
    }
  };

  formatToPhone = (event) => {
    if (this.isModifierKey(event)) {
      return;
    }

    // I am lazy and don't like to type things more than once
    const target = event.target;
    const input = event.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only    
    const zip = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    let targetValue
    if (input.length > 6) { targetValue = `(${zip}) ${middle} - ${last}`; }
    else if (input.length > 3) { targetValue = `(${zip}) ${middle}`; }
    else if (input.length > 0) { targetValue = `(${zip}`; }
    target.value = targetValue
    this.setState({
      phone: targetValue
    })
  };

  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  onChange = dob => this.setState({ dob })

  handleChange = (e) => {
    let value = e.target.value
    if (e.target.id === "firstName" || e.target.id === "lastName") {
      value = value.charAt(0).toUpperCase() + value.slice(1)
    }
    console.log(value)
    this.setState({
      [e.target.id]: value
    })
  }

  handleAddressChange = (e) => {
    let value = e.target.value
    let id = e.target.id
    console.log(value, id)
    if (id == "physicalAddress") {
      this.setState({
        [id]: value,
        mailingAddress: value
      })
    }
    if (id == "physicalCity") {
      this.setState({
        [id]: value,
        mailingCity: value
      })
    }
    if (id == "physicalState") {
      this.setState({
        [id]: value,
        mailingState: value
      })
    }
    if (id == "physicalZip") {
      this.setState({
        [id]: value,
        mailingZip: value
      })
    }
  }


  handleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    db.collection("marketareas").get()
      .then(snapshot => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(marketAreas => {
        const altState = this.state;
        for (let day in altState.hours) {
          altState.hours[day].open = parseInt(altState.hours[day].open);
          altState.hours[day].closed = parseInt(altState.hours[day].closed);
        }

        for (let key in altState) {
          if (typeof altState[key] === 'string') {
            altState[key] = altState[key].trim()
          } else if (Array.isArray(altState[key])) {
            for (let i = 0; i < altState[key].length; i++) {
              if (typeof altState[key][i] === 'string') altState[key][i] = altState[key][i].trim();
            }
          }
        }

        const subZip = altState.physicalZip ? altState.physicalZip.substring(0, 3) : 'randomstring';
        for (let i = 0; i < (marketAreas.length); i++) {
          const marketArea = marketAreas[i]
          const index = marketArea.zips.indexOf(subZip)
          if (index > -1 && !altState.marketAreas.includes(marketArea.fullName)) {
            altState.marketAreas.push(marketArea.fullName)
          }
        }

        updateVendor(altState, this.props.id);
      })
  }

  handleHoursChange = (e) => {
    console.log(e.target.value);
    const [day, time] = e.target.id.split('-');
    const hours = this.state.hours ? this.state.hours : {};
    hours[day] = hours[day] ? hours[day] : { open: '', closed: '', isClosed: false };
    hours[day][time] = e.target.value;
    this.setState({ hours: hours });
  }

  handleToggleHours = (e) => {
    console.log(e.target.value)
    const [day, key] = e.target.id.split('-');
    const hours = this.state.hours ? this.state.hours : {};
    hours[day] = hours[day] ? hours[day] : { open: '', closed: '', isClosed: false };
    hours[day][key] = !hours[day][key];
    this.setState({ hours: hours });
  }

  handleToggleMarketAreas = () => {
    this.setState(prevState => {
      const index = prevState.marketAreas.findIndex(area => area === this.allMAString);
      if (index > -1) {
        prevState.marketAreas.splice(index, 1);
      } else {
        prevState.marketAreas.splice(0, 0, this.allMAString);
      }

      return prevState;
    });
  }

  handleToggleAddress() {
    const mailingIsPhysical = this.state.mailingIsPhysical
    this.setState({
      mailingIsPhysical: !mailingIsPhysical,
      mailingAddress: mailingIsPhysical ? '' : this.state.physicalAddress,
      mailingCity: mailingIsPhysical ? '' : this.state.physicalCity,
      mailingState: mailingIsPhysical ? '' : this.state.physicalState,
      mailingZip: mailingIsPhysical ? '' : this.state.physicalZip
    })
    // this.setState({
    //   [value]: !this.state[value],
    //   mailingAddress: (this.state.mailingAddress ? "" : (this.props.vendor.physicalAddress ? this.props.vendor.physicalAddress : this.state.physicalAddress)),
    //   mailingCity: (this.state.mailingCity ? "" : (this.props.vendor.physicalCity ? this.props.vendor.physicalCity : this.state.physicalCity)),
    //   mailingState: (this.state.mailingState ? "" : (this.props.vendor.physicalState ? this.props.vendor.physicalState : this.state.physicalState)),
    //   mailingZip: (this.state.mailingZip ? "" : (this.props.vendor.physicalZip ? this.props.vendor.physicalZip : this.state.physicalZip))
    // });
  }

  handleToggleSTA() {
    const sta = this.state.sta
    this.setState({
      sta: !sta,
    })
    // this.setState({
    //   [value]: !this.state[value],
    //   mailingAddress: (this.state.mailingAddress ? "" : (this.props.vendor.physicalAddress ? this.props.vendor.physicalAddress : this.state.physicalAddress)),
    //   mailingCity: (this.state.mailingCity ? "" : (this.props.vendor.physicalCity ? this.props.vendor.physicalCity : this.state.physicalCity)),
    //   mailingState: (this.state.mailingState ? "" : (this.props.vendor.physicalState ? this.props.vendor.physicalState : this.state.physicalState)),
    //   mailingZip: (this.state.mailingZip ? "" : (this.props.vendor.physicalZip ? this.props.vendor.physicalZip : this.state.physicalZip))
    // });
  }


  handleToggleTerms(value) {
    const { termGroups } = this.state;
    const currentIndex = termGroups.indexOf(value);
    const newTermGroups = [...termGroups];

    if (currentIndex === -1) {
      newTermGroups.push(value);
    } else {
      newTermGroups.splice(currentIndex, 1);
    }

    this.setState({
      termGroups: newTermGroups
    });
  }



  assignPic = (downloadURL, field) => {
    this.setState({
      [field]: downloadURL
    });
    // this.props.onAssignUser(userID, firstName, lastName, email)
  }

  addNewPhone = () => {
    let newPhoneList = this.state.airCodes
    console.log(this.state.newPhone)
    if (this.state.newPhone != undefined) {
      newPhoneList.push(this.state.newPhone)
      console.log(newPhoneList)
      this.setState({
        airCodes: newPhoneList,
        newPhone: ""
      })
    }
  }

  addNewBranch = () => {
    let newBranchList = this.state.relatedBranches
    newBranchList.push(this.state.newBranch)
    console.log(newBranchList)
    this.setState({
      relatedBranches: newBranchList,
      newBranch: ""
    })
  }
  removeBranch = (code) => {
    this.setState({
      relatedBranches: this.state.relatedBranches.filter(item => item !== code)
    })
  }

  addNewAirport = () => {
    let newBranchList = this.state.relatedAirports
    newBranchList.push(this.state.newBranch)
    console.log(newBranchList)
    this.setState({
      relatedAirports: newBranchList,
      newBranch: ""
    })
  }
  removeAirport = (code) => {
    this.setState({
      relatedAirports: this.state.relatedAirports.filter(item => item !== code)
    })
  }

  removeDriver = (code) => {
    this.setState({
      airCodes: this.state.airCodes.filter(item => item !== code)
    })
  }

  addNewMarketArea = () => {
    let newMarketAreaList = this.state.marketAreas
    console.log(this.state.newMarketArea)
    if (this.state.newMarketArea != undefined) {
      newMarketAreaList.push(this.state.newMarketArea)
      console.log(newMarketAreaList)
      this.setState({
        marketAreas: newMarketAreaList,
        newMarketArea: ""
      })
    }
  }

  removeMarketArea = (market) => {
    this.setState({
      marketAreas: this.state.marketAreas.filter(item => item !== market)
    })
  }

  render() {
    const { classes } = this.props;

    const counties = ['Clark', 'Cowlitz', 'Lewis', 'Pacific', 'Wahkiakum', 'Skamania', 'Klickitat', 'Other']
    const userTypes = ['', 'Shipper', 'Carrier', 'User']
    const vendorTypes = ['', 'Passenger Airline', 'All-Cargo Airline', 'Ground Carrier', 'LTL Carrier', 'Broker', 'Barge', 'Charter Air Operator', 'Fixed Base Operator']
    const marketAreas = ['', 'Ground Carrier', 'Passenger Airline', 'Cargo Airline']
    const militaryTime = ['', '0000', '0100', '0200', '0300', '0400', '0500', '0600', '0700', '0800', '0900', '1000', '1100', '1200', '1300', '1400', '1500', '1600', '1700', '1800', '1900', '2000', '2100', '2200', '2300']

    console.log(this.state)
    console.log(this.props)
    return (
      <div className={classes.formContainer}>
        {/* <form onSubmit={this.handleSubmit} */}
        {
          this.props.vendor ?

            <form onSubmit={this.handleSubmit}
            >
              <GridContainer justify="center">
                <GridItem xs={11}>
                  {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error</h5> : null}
                  <GridContainer>
                    <GridItem xs={12}>
                      {/* <VendorPicUpload onAssignPic={this.assignPic} /> */}

                    </GridItem>
                    <GridItem xs={12} md={6}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}>
                        <InputLabel
                          htmlFor="vendorType"
                          style={{ color: "black !important" }}
                        // className={classes.selectLabel}
                        >
                          Vendor Type:
                      </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu
                          }}
                          style={{ color: "black !important" }}

                          classes={{
                            // select: classes.select
                          }}
                          value={this.state.vendorType}
                          onChange={this.handleSelectChange}
                          inputProps={{
                            id: 'vendorType',
                            name: 'vendorType'
                          }}
                        >
                          {
                            vendorTypes.map((item) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                                value={item}
                                key={item}
                              >{item}</MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Business Name"
                        id="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.name ? this.props.vendor.name : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Physical Address"
                        id="physicalAddress"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleAddressChange(event),
                          defaultValue: this.props.vendor.physicalAddress ? this.props.vendor.physicalAddress : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="City"
                        id="physicalCity"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleAddressChange(event),
                          defaultValue: this.props.vendor.physicalCity ? this.props.vendor.physicalCity : ''
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="State"
                        id="physicalState"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleAddressChange(event),
                          defaultValue: this.props.vendor.physicalState ? this.props.vendor.physicalState : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Zip"
                        id="physicalZip"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleAddressChange(event),
                          defaultValue: this.props.vendor.physicalZip ? this.props.vendor.physicalZip : ''
                        }}
                      />
                    </GridItem>

                    {/*<GridItem xs={12} sm={6}>
                    <Datetime
                      selected={this.state.dob}
                      onChange={this.handleDOBChange}
                      timeFormat={true}
                      isValidDate={this.valid}
                      renderInput={(dateInputProps, open, close) => (
                        <CustomInput
                          inputProps={{ ...dateInputProps, id: 'dob', name: 'dob', required: false, 
                          defaultValue: this.props.user.title ? this.props.user.title : ''
                        }}
                          onBlur={close}
                          onFocus={open}
                          labelText="Date of Birth"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      )}
                    />
                        </GridItem>*/}
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Main Phone"
                        id="mainPhone"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          maxLength: "16",
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.mainPhone ? this.props.vendor.mainPhone : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Business Email"
                        id="email"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          maxLength: "16",
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.email ? this.props.vendor.email : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Location Notes"
                        id="locationNotes"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.locationNotes ? this.props.vendor.locationNotes : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Remit to Parent Connection"
                        id="remit"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.remit ? this.props.vendor.remit : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Motive API Key"
                        id="motiveAPI"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.motiveAPI ? this.props.vendor.motiveAPI : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} md={6}>

                      <div className={classes.checkboxAndRadio}>
                        STA:
                  <FormControlLabel
                          control={
                            <Checkbox
                              tabIndex={-1}
                              onClick={() => this.handleToggleSTA()}
                              checked={this.state.sta}
                              checkedIcon={<Check className={classes.checkedIcon} />}
                              icon={<Check className={classes.uncheckedIcon} style={{ color: "black !imporant" }} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot
                              }}
                            />
                          }
                          classes={{
                            label: classes.label
                          }}
                          label="Enabled"
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12}>
                      <GridContainer>
                        {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => {
                          const lDay = day.toLowerCase();
                          return (
                            <React.Fragment>
                              <GridItem xs={12}>
                                {day}
                              </GridItem>
                              {(this.state.hours && this.state.hours[lDay] && this.state.hours[lDay].isClosed) ? (
                                <GridItem xs={10}>
                                  <p>Closed</p>
                                </GridItem>
                              ) : (
                                  <React.Fragment>
                                    <GridItem xs={5}>
                                      <CustomInput
                                        labelText="Opens At"
                                        id={`${lDay}-open`}
                                        formControlProps={{
                                          fullWidth: true
                                        }}
                                        inputProps={{
                                          type: "number",
                                          onChange: this.handleHoursChange,
                                          defaultValue: (this.state.hours && this.state.hours[lDay] && this.state.hours[lDay].open) ? this.state.hours[lDay].open : ''
                                        }}
                                      />
                                    </GridItem>
                                    <GridItem xs={5}>
                                      <CustomInput
                                        labelText="Closes At"
                                        id={`${lDay}-closed`}
                                        formControlProps={{
                                          fullWidth: true
                                        }}
                                        inputProps={{
                                          type: "number",
                                          onChange: this.handleHoursChange,
                                          defaultValue: (this.state.hours && this.state.hours[lDay] && this.state.hours[lDay].closed) ? this.state.hours[lDay].closed : ''
                                        }}
                                      />
                                    </GridItem>
                                  </React.Fragment>
                                )}

                              <GridItem xs={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <p style={{ display: 'flex', padding: 0, margin: 0 }}>Closed?</p>
                                <Checkbox
                                  tabIndex={-1}
                                  id={`${lDay}-isClosed`}
                                  onClick={this.handleToggleHours}
                                  checked={(this.state.hours && this.state.hours[lDay] && this.state.hours[lDay].isClosed) ? true : false}
                                  checkedIcon={<Check className={classes.checkedIcon} />}
                                  icon={<Check className={classes.uncheckedIcon} style={{ color: "black !imporant" }} />}
                                  classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot
                                  }}
                                  style={{ padding: '8px', margin: '0' }}
                                />
                              </GridItem>
                            </React.Fragment>
                          )
                        })}
                      </GridContainer>
                    </GridItem>
                    <GridItem xs={12} sm={12}>

                      {this.state.airCodes.map(code => {
                        return (
                          <p>{code}<span

                            style={{ color: "red", cursor: "pointer" }}
                            onClick={
                              () => this.removeDriver(code)}
                          > X</span>
                          </p>
                        )
                      })}
                      <div>
                        <CustomInput
                          labelText="Air Codes"
                          id="newPhone"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.newPhone ? this.state.newPhone : ''
                          }}
                        />
                        <Button
                          color="info"
                          onClick={
                            () => this.addNewPhone()}
                        >ADD AIR CODE</Button>
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12}>

                      {this.state.marketAreas.map(market => {
                        return (
                          <p>{market}<span

                            style={{ color: "red", cursor: "pointer" }}
                            onClick={
                              () => this.removeMarketArea(market)}
                          > X</span>
                          </p>
                        )
                      })}
                    </GridItem>
                    <GridItem xs={12}>

                      <GridContainer>
                        <GridItem xs={10}>
                          <CustomInput
                            labelText="Market Areas"
                            id="newMarketArea"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              value: this.state.newMarketArea ? this.state.newMarketArea : ''
                            }}
                          />
                          <Button
                            color="info"
                            onClick={
                              () => this.addNewMarketArea()}
                          >
                            ADD MARKET AREA
                          </Button>
                        </GridItem>
                        <GridItem xs={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <p style={{ display: 'flex', padding: 0, margin: 0 }}>All?</p>
                          <Checkbox
                            tabIndex={-1}
                            onClick={this.handleToggleMarketAreas}
                            checked={this.state.marketAreas.find(area => area === this.allMAString) ? true : false}
                            checkedIcon={<Check className={classes.checkedIcon} />}
                            icon={<Check className={classes.uncheckedIcon} style={{ color: "black !imporant" }} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot
                            }}
                            style={{ padding: '8px', margin: '0' }}
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>

                    {(this.state.vendorType == "LTL Carrier" || this.state.vendorType == "Ground Carrier") &&
                      <GridItem xs={12} sm={12}>
                        {this.state.relatedBranches.map(code => {
                          return (
                            <p>{code}<span

                              style={{ color: "red", cursor: "pointer" }}
                              onClick={
                                () => this.removeBranch(code)}
                            > X</span>
                            </p>
                          )
                        })}
                        <div>
                          <CustomInput
                            labelText="Related Depots/Branches"
                            id="newBranch"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              value: this.state.newBranch ? this.state.newBranch : ''
                            }}
                          />
                          <Button
                            color="info"
                            onClick={
                              () => this.addNewBranch()}
                          >ADD RELATED DEPOT/BRANCH</Button>
                        </div>
                      </GridItem>
                    }
                    {(this.state.vendorType == "Passenger Airline" || this.state.vendorType == "All-Cargo Airline") &&
                      <GridItem xs={12} sm={12}>

                        {this.state.relatedAirports.map(code => {
                          return (
                            <p>{code}<span

                              style={{ color: "red", cursor: "pointer" }}
                              onClick={
                                () => this.removeAirport(code)}
                            > X</span>
                            </p>
                          )
                        })}
                        <div>
                          <CustomInput
                            labelText="Related Airport Locations"
                            id="newAirport"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              value: this.state.newAirport ? this.state.newAirport : ''
                            }}
                          />
                          <Button
                            color="info"
                            onClick={
                              () => this.addNewAirport()}
                          >ADD RELATED AIRPORT LOCATIONS</Button>
                        </div>
                      </GridItem>

                      // <GridItem xs={12} md={6}>
                      //   <FormControl
                      //     fullWidth
                      //     className={classes.selectFormControl}>
                      //     <InputLabel
                      //       htmlFor="vendorType"
                      //       style={{ color: "black !important" }}
                      //     // className={classes.selectLabel}
                      //     >
                      //       Vendor Type:
                      // </InputLabel>
                      //     <Select
                      //       MenuProps={{
                      //         className: classes.selectMenu
                      //       }}
                      //       style={{ color: "black !important" }}

                      //       classes={{
                      //         // select: classes.select
                      //       }}
                      //       value={this.state.vendorType}
                      //       onChange={this.handleSelectChange}
                      //       inputProps={{
                      //         id: 'vendorType',
                      //         name: 'vendorType'
                      //       }}
                      //     >
                      //       {
                      //         vendorTypes.map((item) => (
                      //           <MenuItem
                      //             classes={{
                      //               root: classes.selectMenuItem
                      //             }}
                      //             value={item}
                      //             key={item}
                      //           >{item}</MenuItem>
                      //         ))
                      //       }
                      //     </Select>
                      //   </FormControl>
                      // </GridItem>
                    }
                    {/* <GridItem xs={12} md={6}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}>
                        <InputLabel
                          htmlFor="vendorType"
                          style={{ color: "black !important" }}
                        // className={classes.selectLabel}
                        >
                         Market Area:
                      </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu
                          }}
                          style={{ color: "black !important" }}

                          classes={{
                            // select: classes.select
                          }}
                          value={this.state.marketArea}
                          onChange={this.handleSelectChange}
                          inputProps={{
                            id: 'marketArea',
                            name: 'marketArea'
                          }}
                        >
                          {
                            marketAreas.map((item) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                                value={item}
                                key={item}
                              >{item}</MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                    </GridItem> */}

                    <h3>Accounting / Regulatory</h3>  <br />



                    <div className={classes.checkboxAndRadio}>
                      Mailing address is Physical Address?
                  <FormControlLabel
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => this.handleToggleAddress()}
                            checked={this.state.mailingIsPhysical}
                            checkedIcon={<Check className={classes.checkedIcon} />}
                            icon={<Check className={classes.uncheckedIcon} style={{ color: "black !imporant" }} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="Enabled"
                      />
                    </div>
                    <GridItem xs={12} sm={6}>
                      {this.state.mailingIsPhysical ?
                        <CustomInput
                          labelText="Mailing Address"
                          id="mailingAddress"
                          formControlProps={{
                            fullWidth: true
                          }}
                          labelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.physicalAddress ? this.state.physicalAddress : (this.props.vendor.physicalAddress ? this.props.vendor.physicalAddress : '')
                          }}
                        />
                        :
                        <CustomInput
                          labelText="Mailing Address"
                          id="mailingAddress"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.mailingAddress ? this.state.mailingAddress : ''
                          }}
                        />
                      }
                    </GridItem>
                    <GridItem xs={12} sm={6}>

                      {this.state.mailingIsPhysical ?
                        <CustomInput
                          labelText="City"
                          id="mailingCity"
                          formControlProps={{
                            fullWidth: true
                          }}
                          labelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.physicalCity ? this.state.physicalCity : (this.props.vendor.physicalCity ? this.props.vendor.physicalCity : '')
                          }}
                        />
                        :
                        <CustomInput
                          labelText="City"
                          id="mailingCity"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.mailingCity ? this.state.mailingCity : ''
                          }}
                        />
                      }
                    </GridItem>
                    <GridItem xs={12} sm={6}>

                      {this.state.mailingIsPhysical ?
                        <CustomInput
                          labelText="State"
                          id="mailingState"
                          formControlProps={{
                            fullWidth: true
                          }}
                          labelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.physicalState ? this.state.physicalState : (this.props.vendor.physicalState ? this.props.vendor.physicalState : '')
                          }}
                        />
                        :
                        <CustomInput
                          labelText="State"
                          id="mailingState"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.mailingState ? this.state.mailingState : ''
                          }}
                        />
                      }
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      {this.state.mailingIsPhysical ?
                        <CustomInput
                          labelText="Zip"
                          id="mailingZip"
                          formControlProps={{
                            fullWidth: true
                          }}
                          labelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.physicalZip ? this.state.physicalZip : (this.props.vendor.physicalZip ? this.props.vendor.physicalZip : '')
                          }}
                        />
                        :
                        <CustomInput
                          labelText="Zip"
                          id="mailingZip"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.mailingZip ? this.state.mailingZip : ''
                          }}
                        />
                      }
                    </GridItem>

                    <GridItem xs={12} md={6}>
                      <CustomInput
                        labelText="Accounting Email"
                        id="accountingEmail"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.accountingEmail ? this.props.vendor.accountingEmail : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Quickbooks ID"
                    id="quickbooksID"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      onChange: (event) => this.handleChange(event),
                      defaultValue: this.props.vendor.quickbooksID ? this.props.vendor.quickbooksID : ''
                    }}
                  />
                </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Accounting Notes"
                        id="accountingNotes"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.accountingNotes ? this.props.vendor.accountingNotes : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="Credit Card Interface"
                        id="creditCardInterface"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.creditCardInterface ? this.props.vendor.creditCardInterface : ''
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <CustomInput
                        labelText="DPO"
                        id="dpo"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.props.vendor.dpo ? this.props.vendor.dpo : ''
                        }}
                      />
                    </GridItem>
                    {(this.state.vendorType !== "Passenger Airline" && this.state.vendorType !== "All-Cargo Airline" && this.state.vendorType !== "Charter Air Operator" && this.state.vendorType !== "Fixed Base Operator") &&
                      <GridItem xs={12} sm={6}>
                        <CustomInput
                          labelText="Insurance Information"
                          id="insuranceInformation"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            defaultValue: this.props.vendor.insuranceInformation ? this.props.vendor.insuranceInformation : ''
                          }}
                        />
                      </GridItem>
                    }
                    {(this.state.vendorType !== "Passenger Airline" && this.state.vendorType !== "All-Cargo Airline" && this.state.vendorType !== "Charter Air Operator" && this.state.vendorType !== "Fixed Base Operator") &&

                      <GridItem xs={12} sm={6}>
                        <CustomInput
                          labelText="DOT Number"
                          id="dotNumber"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            defaultValue: this.props.vendor.dotNumber ? this.props.vendor.dotNumber : ''
                          }}
                        />
                      </GridItem>}
                    {(this.state.vendorType !== "Passenger Airline" && this.state.vendorType !== "All-Cargo Airline" && this.state.vendorType !== "Charter Air Operator" && this.state.vendorType !== "Fixed Base Operator") &&

                      <GridItem xs={12} sm={6}>
                        <CustomInput
                          labelText="MC/MX/FF Number"
                          id="mcmxffNumber"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            defaultValue: this.props.vendor.mcmxffNumber ? this.props.vendor.mcmxffNumber : ''
                          }}
                        />
                      </GridItem>}
                    {(this.state.vendorType == "Passenger Airline") &&

                      <GridItem xs={12} sm={6}>
                        <CustomInput
                          labelText="Service Levels"
                          id="serviceLevels"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            defaultValue: this.props.vendor.serviceLevels ? this.props.vendor.serviceLevels : ''
                          }}
                        />
                      </GridItem>}
                    {(this.state.vendorType == "Passenger Airline") &&
                      <GridItem xs={12} sm={6}>
                        <CustomInput
                          labelText="Service Levels Cutoff"
                          id="serviceLevelsCutoff"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            defaultValue: this.props.vendor.serviceLevelsCutoff ? this.props.vendor.serviceLevelsCutoff : ''
                          }}
                        />
                      </GridItem>}
                    {((this.state.vendorType == "Passenger Airline") || (this.state.vendorType == "All-Cargo Airline")) &&
                      <GridItem xs={12} sm={6}>
                        <CustomInput
                          labelText="Haney Freightways Account Number"
                          id="cargorxAccountNumber"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            defaultValue: this.props.vendor.cargorxAccountNumber ? this.props.vendor.cargorxAccountNumber : ''
                          }}
                        />
                      </GridItem>}
                    {/*<GridItem xs={6}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}>
                      <InputLabel
                        htmlFor="county"
                        className={classes.selectLabel}>
                        County:
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.county}
                        onChange={this.handleSelectChange}
                        inputProps={{
                          id: 'county',
                          name: 'county'
                        }}
                      >
                        {
                          counties.map((item) => (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem
                              }}
                              value={item}
                              key={item}
                            >{item}</MenuItem>
                          ))
                        }
                      </Select>
                    </FormControl>
                      </GridItem>*/}


                  </GridContainer>
                  {/*<FormControl
                      fullWidth
                      className={classes.selectFormControl}>
                      <InputLabel
                        htmlFor="userType"
                        className={classes.selectLabel}>
                        User Type:
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.userType}
                        onChange={this.handleSelectChange}
                        inputProps={{
                          id: 'userType',
                          name: 'userType'
                        }}
                      >
                        {
                          userTypes.map((item) => (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem
                              }}
                              value={item}
                              key={item}
                            >{item}</MenuItem>
                          ))
                        }
                      </Select>
                      </FormControl>*/}

                  <h5 className={classes.bodyText}>APPROVAL DOCUMENTS</h5>
                  {(this.state.vendorType == "Passenger Airline" || this.state.vendorType == "All-Cargo Airline") &&
                    <VendorPicUpload onAssignPic={this.assignPic} label="Upload Airline Sample Waybill" field="waybillURL" />
                  }
                  {(this.state.vendorType !== "Passenger Airline" && this.state.vendorType !== "All-Cargo Airline" && this.state.vendorType !== "Charter Air Operator" && this.state.vendorType !== "Fixed Base Operator") &&
                    <div>
                      <VendorPicUpload onAssignPic={this.assignPic} label="Upload Insurance Information" field="insuranceURL" />
                      {this.props.vendor && (this.props.vendor.insuranceURL && "On File")}
                      <VendorPicUpload onAssignPic={this.assignPic} label="Upload TSA Letter" field="tsaURL" />
                      {this.props.vendor && (this.props.vendor.tsaURL && "On File")}
                      <VendorPicUpload onAssignPic={this.assignPic} label="Upload Broker Carrier Agreement" field="agreementURL" />
                      {this.props.vendor && (this.props.vendor.agreementURL && "On File")}
                      <VendorPicUpload onAssignPic={this.assignPic} label="Upload W9" field="w9URL" />
                      {this.props.vendor && (this.props.vendor.w9URL && "On File")}
                    </div>
                  }
                </GridItem>
              </GridContainer>
              <Button
                type="submit"
                color="primary"
                style={{
                  marginLeft: "10px",
                  marginBottom: "10px"
                }}
              >
                Save Changes
            </Button>
            </form>
            :
            null

        }
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Form);



// WEBPACK FOOTER //
// ./src/components/Forms/vendorProfileForm.jsx